import { Component, OnDestroy, OnInit, AfterViewInit, ViewChild, ElementRef } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AuthService } from "../../services/auth.service";
import { ConfigurationService } from "../../services/configuration.service";
import { RoutesService } from "../../services/routes.service";
import { CiamUserService } from "../../services/ciamuser.service";
import { Title } from "@angular/platform-browser";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { environment } from '../../../environments/environment';

@Component({
    selector: "splash",
    templateUrl: "./splash.component.html",
    standalone: false
})
export class SplashComponent implements OnInit, AfterViewInit, OnDestroy {
    private destroy$ = new Subject<void>();
    emailForm!: FormGroup;
    whitelistedDomains: string[] = [];
    isDeloitteDomain: boolean = false;
    isLoading: boolean = false;
    @ViewChild('emailInput') emailInput!: ElementRef<HTMLInputElement>;


    constructor(private authService: AuthService, private configurationService: ConfigurationService, private routesService: RoutesService, private titleService: Title, private ciamUserService: CiamUserService, private toastrService: ToastrService) {
        this.authService.businessFunction = null;
        this.authService.user = null;

        this.titleService.setTitle("Splash");
        this.routesService.currentPageTitle.next('Splash Screen');
        this.createForm();
    }

    ngOnInit(): void {
        // Restore email from sessionStorage if available (for browser back button scenario)
        const savedEmail = sessionStorage.getItem('splash_email');
        if (savedEmail) {
            this.emailForm.patchValue({ email: savedEmail });
        }
    }

    ngAfterViewInit(): void {
        // Handle browser auto-fill on back button navigation
        // Give the browser a moment to auto-fill, then sync with FormControl
        setTimeout(() => {
            if (this.emailInput?.nativeElement?.value && !this.emailForm.get('email')?.value) {
                this.emailForm.patchValue({ email: this.emailInput.nativeElement.value });
            }
        }, 100);
    }

    createForm(): void {
        this.emailForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email])
        });
    }

    submitEmail(): void {
        this.emailForm.markAllAsTouched();
        if (this.emailForm.valid) {
            const email = this.emailForm.get('email')?.value;

            // Save email to sessionStorage for browser back button scenario
            sessionStorage.setItem('splash_email', email);

            const emailDomain = email.substring(email.lastIndexOf('@') + 1).toLowerCase();
            this.isDeloitteDomain = emailDomain.includes('deloitte');

            this.isLoading = true;
            const loginRedirectUrl = `${environment.loginRedirectUrl}?email=${encodeURIComponent(email)}`;
            if (this.isDeloitteDomain) {
                window.location.href = loginRedirectUrl;
            }
            else {
                this.ciamUserService.inviteExternalUser(email)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe({
                        next: (result) => {
                            this.isLoading = false;
                            if (result && result.isSuccess) {
                                window.location.href = loginRedirectUrl;
                            } else {
                                this.toastrService.error('Failed to login.' + (result?.message || ' Please try again later.'));
                            }
                        },
                        error: (error) => {
                            this.isLoading = false;
                            this.toastrService.error('An error occurred while sending the invitation. Please try again later.');
                        }
                    });
            }
        } else {
            this.toastrService.warning('Please enter a valid email address.');
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}